import { JsonPipe } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BulkOperationType } from 'listings/enums/bulk-operation-type.enum';
import { BaseModal } from 'shared/abstract/base-modal';

@Component({
    selector: 'app-full-exports-confirmation-modal',
    templateUrl: './full-exports-confirmation-modal.component.html',
    styleUrl: './full-exports-confirmation-modal.component.scss',
    imports: [TranslateModule],
})
export class FullExportsConfirmationModalComponent extends BaseModal {
    data: any;

    protected readonly BulkOperationType = BulkOperationType;
}
